<template>
  <div>
    <div class="coverShow" v-show="viseable">
      <div class="container-gj" @click="handleCloseClick">
        <div class="container-gd" @click.stop>
          <div class="header">
            <p>选择题目</p>
            <i
              class="fa-solid fa-circle-xmark"
              style="color: #8290a3; cursor: pointer"
              @click="handleCloseClick"
            ></i>
          </div>
          <div class="tab-container">
            <div
              :class="
                activeIndex == 1 ? 'tab-item-active' : 'tab-item-inactive'
              "
              @click="handleLibraryTab(1)"
            >
              <p>我的题库</p>
              <span></span>
            </div>
            <div
              :class="
                activeIndex == 2 ? 'tab-item-active' : 'tab-item-inactive'
              "
              @click="handleLibraryTab(2)"
            >
              <p>常用题库</p>
              <span></span>
            </div>
          </div>
          <div v-if="activeIndex == 1">
            <div class="library-content-header">
              <div class="library-content-header-left">
                <el-select
                  v-model="myLibraryName"
                  placeholder="题库名称"
                  style="width: 180px; background: #f7f7f7; border: 1px solid #ededed; margin-right: 10px;"
                  @change="handleSelectChange($event, 1)"
                >
                  <el-option
                    v-for="item in myLibraryList"
                    :key="item.value"
                    :label="item.label"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="myTypeLabel"
                  placeholder="题型"
                  style="width: 180px; background: #f7f7f7; border: 1px solid #ededed;"
                  @change="handleSelectChange($event, 2)"
                >
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <div class="search-input">
                  <input
                    v-model="myInputValue"
                    placeholder="请输入"
                    clearable
                  ></input>
                </div>
                <el-button type="primary" icon="el-icon-search" style="margin-left: 10px;" @click="handleSearchClick"></el-button>
              </div>
              <div class="library-content-header-right">
                <el-button type="primary" icon="el-icon-plus" @click="handleAddClick">添加题目</el-button>
              </div>
            </div>
            <div class="library-content-list">
              <el-table
                :data="myLibraryQuestionList"
                :border="true"
                style="width: 100%; margin-top: 10px;"
                :header-cell-style="{ background: '#F6F7FA' }"
                :cell-style="{ background: '#ffffff' }"
                :row-key="getMyRowKey"
                @selection-change="handleMySelectionChange"
                ref="myTable"
              >
                <el-table-column type="selection" :align="'center'" width="55" :reserve-selection="true"></el-table-column>
                <el-table-column prop="type" label="题目类型" :align="'center'" width="120">  
                  <template slot-scope="scope">
                    <p>{{ getTypeString(scope.row.type) }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="题目名称" :align="'center'">
                  <template slot-scope="scope">
                    <p>{{ scope.row.caseProblem }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="library-content-pagination">
              <el-button style="color: #1877FF; border: 1px solid #1877FF; font-size: 14px; font-weight: Semibold;" @click="handleAddAllClick">全部导入</el-button>
              <el-pagination background :page-size="myPageSize" :current-page.sync="myCurrentPage" @size-change="handleMyPageSizeChange" @current-change="handleMyCurrentChange" layout="total, prev, pager, next, jumper" :total="myTotal"></el-pagination>
            </div>
          </div>
          <div v-if="activeIndex == 2">
            <div class="library-content-header">
              <div class="library-content-header-left">
                <el-select
                  v-model="cyCategoryLabel"
                  placeholder="问卷类型"
                  style="width: 180px; background: #f7f7f7; border: 1px solid #ededed; margin-right: 10px;"
                  @change="handleSelectChange($event, 3)"
                >
                  <el-option
                    v-for="item in cyCategoryOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="cyLibraryName"
                  placeholder="题库名称"
                  style="width: 180px; background: #f7f7f7; border: 1px solid #ededed; margin-right: 10px;"
                  @change="handleSelectChange($event, 4)"
                >
                  <el-option
                    v-for="item in cyLibraryList"
                    :key="item.value"
                    :label="item.label"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="cyTypeLabel"
                  placeholder="题型"
                  style="width: 180px; background: #f7f7f7; border: 1px solid #ededed;"
                  @change="handleSelectChange($event, 5)"
                >
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <div class="search-input">
                  <input
                    v-model="cyInputValue"
                    placeholder="请输入题目名称"
                    clearable
                  ></input>
                </div>
                <el-button type="primary" icon="el-icon-search" style="margin-left: 10px;" @click="handleSearchClick"></el-button>
              </div>
            </div>
            <div class="library-content-list">
              <el-table
                :data="cyLibraryQuestionList"
                :border="true"
                style="width: 100%; margin-top: 10px;"
                :header-cell-style="{ background: '#F6F7FA' }"
                :cell-style="{ background: '#ffffff' }"
                :row-key="getCyRowKey"
                @selection-change="handleCySelectionChange"
                ref="cyTable"
              >
                <el-table-column type="selection" :align="'center'" width="55" :reserve-selection="true"></el-table-column>
                <el-table-column prop="type" label="题目类型" :align="'center'" width="120">  
                  <template slot-scope="scope">
                    <p>{{ getTypeString(scope.row.type) }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="题目名称" :align="'center'">
                  <template slot-scope="scope">
                    <p>{{ scope.row.caseProblem }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="library-content-pagination">
              <el-button style="color: #1877FF; border: 1px solid #1877FF; font-size: 14px; font-weight: Semibold;" @click="handleAddAllClick">全部导入</el-button>
              <el-pagination background :page-size="cyPageSize" :current-page.sync="cyCurrentPage" @size-change="handleCyPageSizeChange" @current-change="handleCyCurrentChange" layout="total, prev, pager, next, jumper" :total="cyTotal"></el-pagination>
            </div>
          </div>
          <div class="library-content-footer">
            <div class="library-content-footer-left">
              <!-- <p>如果没有您想要添加的考题，建议您<span>【添加考题】</span></p> -->
            </div>
            <div class="library-content-footer-right">
              <el-button style="color: #1877FF; border: 1px solid #1877FF; font-size: 14px; font-weight: Semibold; width: 89px;" @click="handleCloseClick">取消</el-button>
              <el-button type="primary" @click="handleConfirmClick" style="width: 89px;">确认</el-button> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <LibraryEditDialog :showDialog.sync="showAddDialog" :uuid="myLibraryId" @closeDialog="showAddDialog = false" :params="dataObj" :operate="libraryOperate"></LibraryEditDialog>
  </div>
</template>

<script>
import { createPCUserLibrary, userLibraryList, myLibraryQuestionList, cyLibraryQuestionList, deletePCUserLibraryQuestion, libraryList, addLibraryToQuestionnaire, addUserLibraryToQuestionnaire } from "@/api/index.js";
import LibraryEditDialog from "@/components/LibraryEditDialog/index.vue";
export default {
  components: {
    LibraryEditDialog,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    libraryType: {
      type: String,
      default: "1",
    },
    uuid: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      viseable: false,
      loading: null,
      categoryOptions: [],
      nameOptions: [],
      typeOptions: [
        {
          value: "",
          label: "全部题型",
        },
        {
          value: "1",
          label: "单选题",
        },
        {
          value: "2",
          label: "多选题",
        },
        {
          value: "3",
          label: "填空题",
        },
        {
          value: "4",
          label: "多项填空",
        },
        {
          value: "5",
          label: "下拉",
        },
        {
          value: "6",
          label: "NPS",
        },
        {
          value: "7",
          label: "投票",
        },
        {
          value: "8",
          label: "排序",
        },
        {
          value: "9",
          label: "备注",
        },
        {
          value: "10",
          label: "分数评定",
        },
        {
          value: "11",
          label: "问答",
        },
        {
          value: "12",
          label: "权重评分",
        },
        {
          value: "13",
          label: "评星",
        },
        {
          value: "14",
          label: "姓名",
        },
        {
          value: "15",
          label: "性别",
        },
        {
          value: "16",
          label: "年龄",
        },
        {
          value: "17",
          label: "电话号",
        },
        {
          value: "18",
          label: "邮箱",
        },
        {
          value: "19",
          label: "日期",
        },
        {
          value: "20",
          label: "时间",
        },
        {
          value: "21",
          label: "地址",
        },
        {
          value: "23",
          label: "图片",
        },
        {
          value: "24",
          label: "MaxDiff题",
        }
        ,
        {
          value: "25",
          label: "上传文件",
        },
        {
          value: "26",
          label: "下载附件",
        },
        {
          value: "27",
          label: "联极题",
        },
        // {
        //   value: "28",
        //   label: "完形填空",
        // },
        {
          value: "29",
          label: "出生日期",
        },
        {
          value: "30",
          label: "身份证号",
        },
        {
          value: "31",
          label: "学历",
        },
        {
          value: "32",
          label: "微信号",
        },
      ],
      QuestionType: this.$store.getters['questionType/getQuestionType'],
      value: "",
      activeIndex: 1,
    
      myTotal: null,
      myCurrentPage: 1,
      myPageSize: 10,
      myLibraryList: [],
      myLibraryQuestionList: [],
      cyLibraryId: null,
      cyTotal: 0,
      cyCurrentPage: 1,
      cyPageSize: 10,
      cyCategoryOptions: [],
      cyLibraryList: [],
      cyLibraryQuestionList: [],
      // currentPage: 1,
      // pageSize: 10,
      selectValue: null,
      mySelectedRows: [],
      cySelectedRows: [],
      myLibraryName: '',
      cyLibraryName: '',
      myLibraryId: '',
      cyLibraryId: '',
      myTypeValue: null,
      myTypeLabel: null,
      cyTypeValue: null,
      cyTypeLabel: null,
      cyCategoryLabel: '',
      cyCategoryValue: null,
      myInputValue: '',
      cyInputValue: '',
      // showDialog: false,
      libraryOperate: '0',
      dataObj: null,
      showAddDialog: false,
    };
  },
  methods: {
    handleCloseClick() {
      this.$emit("close");
    },
    handleMyPageSizeChange(val) {
      this.myPageSize = val;
      this.getMyLibraryQuestionList();
    },
    handleMyCurrentChange(val) {
      this.myCurrentPage = val;
      this.getMyLibraryQuestionList();
    },
    handleCyPageSizeChange(val) {
      this.cyPageSize = val;
      this.getCyLibraryQuestionList();
    },
    handleCyCurrentChange(val) {
      this.cyCurrentPage = val;
      this.getCyLibraryQuestionList();
    },
    getMyRowKey(row) {
      return row.id
    },
    getCyRowKey(row) {
      return row.id
    },
    handleMySelectionChange(val) {
      this.mySelectedRows = val;
      console.log(this.mySelectedRows);
    },
    handleCySelectionChange(val) {
      this.cySelectedRows = val;
      console.log(this.cySelectedRows);
    },
    handleSearchClick() {
      if (this.activeIndex === 1) {
        this.myCurrentPage = 1;
        this.getMyLibraryQuestionList();
      } else {
        this.cyCurrentPage = 1;
        this.getCyLibraryQuestionList();
      }
      
    },
    handleSelectChange(e, type) {
      console.log(e, type);
      if (type === 1) {
        // this.cyCategoryOptions = e;
        this.myLibraryId = e.value;
        this.getMyLibraryQuestionList();
      } else if (type === 2) {
        this.myTypeValue = e.value;        
        this.getMyLibraryQuestionList();
      } else if (type === 3) {
        // this.cyLibraryId = e.value;
        this.cyLibraryList = e.list.map(item => {
          return {
            label: item.libraryName,
            value: item.id,
          }
        });
        this.cyLibraryName = "";
        this.cyLibraryId = e.value;
        this.getCyLibraryQuestionList();
      } else if (type === 4) {
        this.cyLibraryId = e.value;
        this.getCyLibraryQuestionList()
      } else if (type === 5) {
        this.cyTypeValue = e.value;
        this.getCyLibraryQuestionList()
      } else {

      }
    },
    handleAddClick() {
      if (this.myLibraryList.length === 0) {
        this.$message({
          message: '请创建题库',
          type: 'error',
        });
        return;
      }
      this.$emit("close")
      this.showAddDialog = true;
    },
    handleLibraryTab(index) {
      this.activeIndex = index;
    },
    handleConfirmClick() {
      if (this.activeIndex === 1) {
        this.$emit("confirm", this.mySelectedRows);
      } else {
        this.$emit("confirm", this.cySelectedRows);
      }
    },
    handleAddAllClick() {
      if (this.myLibraryList.length === 0) {
        this.$message({
          message: '请先创建题库',
          type: 'error',
        });
        return;
      }
      // 先判断是否有选择题库
      if (this.activeIndex === 1) {
        addUserLibraryToQuestionnaire
        ({
          uuid: this.uuid,
          libraryId: this.myLibraryId,
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success',
            });
            this.$emit("import");
          }
        }).catch(err => {
          this.$message({
            message: err.msg,
            type: 'error',
          });
        })
      } else {
        // 先判断是否有选择题库
        if (this.cyLibraryName === '') {
          this.$message({
            message: '请选择题库名称',
            type: 'error',
          });
          return;
        }
        addLibraryToQuestionnaire
        ({
          uuid: this.uuid,
          libraryId: this.cyLibraryId,
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success',
            });
            this.$emit("import");
          }
        }).catch(err => {
          this.$message({
            message: err.msg,
            type: 'error',
          });
        })
      }
    },
    getTypeString(type) {
      console.log("0439506489057086408604564645",type, this.QuestionType);
      
      switch (type) {
        case this.QuestionType.SCQ:
          return '单选';
        case this.QuestionType.MCQ:
          return '多选';
        case this.QuestionType.SBQ:
          return '填空';
        case this.QuestionType.MBQ:
          return '多项填空';
        case this.QuestionType.DLQ:
          return '下拉';
        case this.QuestionType.NPS:
          return 'NPS';
        case this.QuestionType.VOTE:
          return '投票';
        case this.QuestionType.SORT:
          return '排序';
        case this.QuestionType.REMARK:
          return '备注';
        case this.QuestionType.SCORE:
          return '分数评定';
        case this.QuestionType.QA:
          return '问答';
        case this.QuestionType.WRQ:
          return '权重评分';
        case this.QuestionType.SRQ:
          return '评星';
        case this.QuestionType.NAME:
          return '姓名';
        case this.QuestionType.GENDER:
          return '性别';
        case this.QuestionType.AGE:
          return '年龄';
        case this.QuestionType.TEL:
          return '电话号';
        case this.QuestionType.EMAIL:
          return '邮箱';
        case this.QuestionType.DATE:
          return '日期';
        case this.QuestionType.TIME:
          return '时间';
        case this.QuestionType.ADDR:
          return '地址';
        case this.QuestionType.TFQ:
          return '判断题';
        case this.QuestionType.IMAGE:
          return '图片';
        case this.QuestionType.MaxDiff:
          return "MaxDiff题";
        case this.QuestionType.UploadFile:
          return "上传文件";
        case this.QuestionType.DownloadFile:
          return "下载文件";
        case this.QuestionType.CASCADER:
          return "联级题";
        case this.QuestionType.BDQ:
          return "出生日期";
        case this.QuestionType.IDQ:
          return "身份证号";
        case this.QuestionType.ELQ:
          return "学历";
        case this.QuestionType.WX:
          return "微信号";
      }
    },
    getUserLibraryList() {
      userLibraryList({
        libraryType: this.libraryType,
      }).then(res => {
        console.log("==============99999", res);
        if (res.code === 200) {
          this.myLibraryList = res.data.map(item => {
            return {
              label: item.libraryName,
              value: item.id,
            }
          });
          this.myLibraryName = this.myLibraryList[0].label;
          this.myLibraryId = res.data[0].id;
          console.log("i912u9ry18r2189r21yr981-myLibraryId", this.myLibraryId);

          this.getMyLibraryQuestionList();
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
        
      }).catch(err => {
        
      })
    },
    getLibraryList() {
      libraryList({
        libraryType: this.libraryType,
      }).then(res => {
        console.log("==============666", res);
        if (res.code === 200) {
          this.cyCategoryOptions = res.data.map(item => {
            return {
              label: item.libraryName,
              value: item.id,
              list: item.list
            }
          });
          // this.cyLibraryId = res.data[0].list[0].id;
          console.log("i912u9ry18r2189r21yr981-cyLibraryId", this.cyLibraryId);
          console.log("i912u9ry18r2189r21yr981-cyLibraryId", this.cyLibraryId);
          this.getCyLibraryQuestionList();
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      }).catch(err => {
        
      })
    },
    getMyLibraryQuestionList() { // 我的题库问题列表
      myLibraryQuestionList({
        libraryId: this.myLibraryId,
        pageNum: this.myCurrentPage,
        pageSize: this.myPageSize,
        type: this.myTypeValue,
        caseProblem: this.myInputValue,
      }).then(res => {
        console.log("==============myLibraryQuestionList", res);
        if (res.code === 200) {
          this.myLibraryQuestionList = res.rows;
          this.myTotal = res.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      }).catch(err => {
        
      })
    },
    getCyLibraryQuestionList() { // 常用题库问题列表
      cyLibraryQuestionList({
        libraryId: this.cyLibraryId,
        pageNum: this.cyCurrentPage,
        pageSize: this.cyPageSize,
        type: this.cyTypeValue,
        caseProblem: this.cyInputValue,
      }).then(res => {
        console.log("==============cyLibraryQuestionList", res);
        if (res.code === 200) {
          this.cyLibraryQuestionList = res.rows;
          this.cyTotal = res.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      }).catch(err => {
        
      })
    },
  },
  watch: {
    showDialog(newVal) {
      this.mySelectedRows = [];
      this.cySelectedRows = [];
      this.$nextTick(() => {
        this.$refs.myTable.clearSelection();
      })
      this.$nextTick(() => {
        this.$refs.cyTable.clearSelection();
      })

      this.viseable = newVal;
      this.getUserLibraryList();
      this.getLibraryList();
    },
    // params(newVal) {
    //   console.log("params111111", newVal);
    //   if (newVal != null) {
    //     this.dataObj = newVal;
    //   } else {
    //     this.dataObj = this.dataList[0].data;
    //   }
    //   console.log("dataObj111111", this.dataObj);
    // },
  },
};
</script>

<style scoped>
.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1009;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1009;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 930px;
  /* height: 600px; */
  background: #ffffff;
  z-index: 1009;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

.header {
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;

  p {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  i {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

.tab-container {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.tab-item-active {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin-left: 20px;
  padding-top: 10px;
  cursor: pointer;
}

.tab-item-inactive {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin-left: 20px;
  padding-top: 10px;
  cursor: pointer;
}

.tab-item-active p {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}

.tab-item-inactive p {
  font-size: 16px;
  font-weight: 500;
  color: #999999;
}

.tab-item-active span {
  width: 80%;
  height: 4px;
  background: #1890ff;
  border-radius: 2px;
}

.library-content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 10px;
}

.library-content-header-left {
  display: flex;
  align-items: center;
}

.library-content-header-right {
  display: flex;
  align-items: center;
}

.search-input {
  width: 180px;
  height: 42px;
  background: #f7f7f7;
  border: 1px solid #ededed;
  border-radius: 3px;
  padding: 0 10px;
  box-sizing: border-box;
  margin-left: 10px;
  display: flex;
  align-items: center;

  input {
    width: 100%;
  }
}

.search-btn {
  width: 56px;
  height: 42px;
  background: #1877ff;
  border: 1px solid #1877ff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.library-content-list {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

.library-content-pagination {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-pagination {
  .el-pagination__total {
    font-size: 16px !important;
    color: #909399;
  }

  .el-pagination__sizes {
    .el-select {
        border: 1px solid #F1F3F8;
        border-radius: 3px;
        margin-top: -2px;
      .el-input {
        input {
          font-size: 16px !important;
          color: #909399;
        }  
      }
    }
  }

  .btn-prev {
    .el-icon {
      font-size: 16px !important;
      color: #909399;
    }
  }
  
  .el-pager {
    li {
      font-size: 16px !important;
    }
  }

  .btn-next {
    .el-icon {
      font-size: 16px !important;
      color: #909399;
    }
  }

  .el-pagination__jump {
    font-size: 16px !important;
    color: #909399;

    .el-input {
      .el-input__inner {
        font-size: 16px !important;
        color: #C0C4CC;
      }
      
    }
  }
}

.library-content-footer {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.library-content-footer-left {
  display: flex;
  align-items: center;
}

.library-content-footer-right {
  display: flex;
  align-items: center;
}

.library-content-footer-left p {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  text-align: left;
  color: #4c4a56;
  line-height: 20px;
}

.library-content-footer-left p span {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  text-align: left;
  color: #1877FF;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/LibraryChooseDialog/index.vue